import React, { useCallback } from 'react';
import { classnames } from '@bydesign-ui/utils';
import { usePrefixCls } from '@byte-design/config';
import { useFileUpdate, useUpload } from '../rc-upload/';
import { Picture } from './Picture';
import { ProgressBar } from './ProgressBar';
import { CloseSmall } from './../../../common/icons';
export function CardFileListItem(props) {
  var file = props.file,
      domRef = props.domRef,
      iconRender = props.iconRender;
  var status = file.fileStatus;
  var fileUpload = useUpload();
  var cardFileListItemCls = usePrefixCls('upload-file-list-card-item');
  var cardFileListItemNameCls = usePrefixCls('upload-file-list-card-item-name');
  var cardFileListItemCloseCls = usePrefixCls('upload-file-list-card-item-close');
  var cardFileListItemContentCls = usePrefixCls('upload-file-list-card-item-content');
  var cardFileListItemInfoCls = usePrefixCls('upload-file-list-card-item-info');
  var cardFileListItemErrorCls = usePrefixCls('upload-file-list-card-item-error');
  var linkCls = classnames(usePrefixCls('link'), usePrefixCls('upload-file-list-card-item-link'));
  var removeFile = useCallback(function () {
    fileUpload.removeFileById(file.id);
  }, []);
  useFileUpdate(file.id);
  var progress = file.getProgress();
  return React.createElement("li", {
    className: cardFileListItemCls,
    "data-status": status,
    ref: domRef
  }, React.createElement("div", {
    className: cardFileListItemContentCls
  }, React.createElement(Picture, {
    file: file,
    border: false,
    size: {
      width: 32,
      height: 32
    },
    iconRender: iconRender
  }), React.createElement("div", {
    className: cardFileListItemInfoCls
  }, React.createElement("div", {
    className: cardFileListItemNameCls,
    title: file.name
  }, file.href ? React.createElement("a", {
    className: linkCls,
    href: file.href,
    target: "_blank",
    rel: "noreferrer"
  }, file.name) : React.createElement("span", {
    "data-src": file.url
  }, file.name), React.createElement(CloseSmall, {
    className: cardFileListItemCloseCls,
    onClick: removeFile
  })), React.createElement(ProgressBar, {
    progress: progress,
    done: status === "DONE" || status === "FAIL"
  }))), file.fileStatus === "FAIL" && React.createElement("div", {
    className: cardFileListItemErrorCls
  }, file.errmsg));
}